module.exports = __webpack_public_path__ + "static/media/monica.6061e7c6.png";